module.exports = __webpack_public_path__ + "img/modal-consulta-login-01.7805e81b.jpg";